import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomDialog from 'src/app/components/CustomDialog';
import { updateUser } from 'src/features/userSlice';
import * as Yup from 'yup';

function EditUser({ open, onClose, userSelected }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);

  const userStatus = [
    {
      label: 'Hoạt động',
      value: 1
    },
    {
      label: 'Tạm dừng',
      value: 0
    },
  ]

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = data => {
    if (!userSelected || !userSelected?.id) return;
    const newUser = {
      username: data.username,
      full_name: data.full_name,
      email: data.email,
      phone: data.phone,
      citizen_id: data.citizen_id,
      address: data.address,
      dob: null,
      status: data.status
    }
    dispatch(updateUser({ id: userSelected.id, data: newUser }));
    onClose();
  };

  return (
    <CustomDialog title="Chỉnh sửa khách hàng" open={open} onClose={handleClose}>
      <div>
        <Formik
          initialValues={{
            username: userSelected.username || '',
            full_name: userSelected.full_name || '',
            email: userSelected.email || '',
            phone: userSelected.phone || '',
            citizen_id: userSelected.citizen_id || '',
            address: userSelected.address || '',
            status: userSelected.status || ''
          }}
          validationSchema={Yup.object().shape({
            full_name: Yup.string()
              .max(100)
              .required('Tên không được để trống'),
            phone: Yup.string()
              .matches(
                /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
                'Số điện thoại chưa đúng định dạng'
              )
              .required('Số điện thoại không được để trống'),
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel>Tên khách hàng <span style={{ color: 'red' }}></span></InputLabel>
                  <TextField
                    error={Boolean(
                      touched.full_name && errors.full_name
                    )}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.full_name && errors.full_name}
                    margin="normal"
                    name="full_name"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.full_name}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>Số điện thoại <span style={{ color: 'red' }}></span></InputLabel>
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    fullWidth
                    className="input-no-fieldset"
                    helperText={touched.phone && errors.phone}
                    margin="normal"
                    size="small"
                    name="phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>Tên đăng nhập<span style={{ color: 'red' }}></span></InputLabel>
                  <TextField
                    error={Boolean(touched.username && errors.username)}
                    fullWidth
                    className="input-no-fieldset"
                    helperText={touched.username && errors.username}
                    margin="normal"
                    size="small"
                    name="username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>Tỉnh thành <span className="text-danger"></span></InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listProvinces || []}
                    getOptionLabel={option => option.name}
                    value={(listProvinces || []).find(
                      option => String(option.id) === String(values.citizen_id)
                    )}
                    onChange={(e, value) => setFieldValue("citizen_id", String(value.id))}
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn tỉnh thành"
                        name="citizen_id"
                        error={Boolean(touched.citizen_id && errors.citizen_id)}
                        helperText={touched.citizen_id && errors.citizen_id}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px',
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>Địa chỉ<span style={{ color: 'red' }}></span></InputLabel>
                  <TextField
                    error={Boolean(
                      touched.address && errors.address
                    )}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.address && errors.address}
                    margin="normal"
                    name="address"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>Email <span style={{ color: 'red' }}></span></InputLabel>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    variant="outlined"
                  />
                </Grid>{' '}
                <Grid item md={6} xs={12}>
                  <InputLabel>Trạng thái <span className="text-danger"></span></InputLabel>
                  <TextField
                    className="input-no-fieldset"
                    size="small"
                    fullWidth
                    select
                    helperText={touched.agency_id && errors.agency_id}
                    margin="normal"
                    name="status"
                    onBlur={handleBlur}
                    onChange={(e) => setFieldValue('status', Number(e.target.value))}
                    SelectProps={{
                      native: true
                    }}
                    value={values.status}
                    variant="outlined"
                  >
                    <option>Chọn trạng thái</option>
                    {userStatus && userStatus.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>

              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.wrapper}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={() => handleClose()}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Lưu lại
                    </Button>
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(EditUser);
